<!-- 我的账号 -->
<template>
  <div style="min-width:1000px;">
    <!-- 基本资料 -->
    <section style="min-width:900px;" >
      <!-- 基本资料修改 -->
      <el-tabs class="" v-model="activeName" @tab-click="handleClick" >
          <el-tab-pane label="基本资料" name="first" >
             <div class="jczl_div">
              <span class="jczl_span1">
                个人基本资料
              </span></br>
              <span class="jczl_span2">
                这是您用于访问和管理帐户的个人信息
              </span>
            </div>
            <div style="padding:50px 0 50px 20px;background:#fff;border:1px solid #dfe6ec;">
               <div style="height:160px;">
                <img v-if="upLoadFileListd" class="heard_img"  :src="upLoadFileListd">
                <img v-else class="heard_img" src="../../../assets/tx.jpg">
                <upload @handleUploadSuccess="hadSuccess"  :fileList="upLoadFileList"  
                :picIdes="picid"> 上传图片</upload>
              </div>
               <el-form label-width="100px" label-left="50px" ref="user" >
                <el-row>
                  <el-col :span="15" > 
                    <el-form-item label="登录账号:" prop="phone">
                      {{user.phone}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="15" > 
                    <el-form-item label="注册时间:" prop="registertime">
                      {{user.registertime}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="15" style="padding-top: 10px"> 
                    <el-form-item label="姓名:" prop="name">
                      <el-input class="name_class" v-model="user.name"   auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="15" > 
                    <el-form-item label="企业名称:" prop="company">
                      <el-input class="name_class" v-model="user.company"   auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer1">
                <el-button type="primary"  class="zlsub" @click.native="editSubmit" :loading="editLoading">提交</el-button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="密码修改" name="second">
            <div class="jczl_div">
              <span class="jczl_span1">
                密码修改
              </span></br>
              <span class="jczl_span2">
                修改密码需要手机号验证您的身份。如果您遇到困难或无法修改，请联系我们的业务员！
              </span>
            </div>
            <div style="padding:50px 0 50px 20px;background:#fff;border:1px solid #dfe6ec;">
              <el-form label-width="100px" label-left="50px" ref="mimaForm" >
                <el-row >
                  <el-col :span="20" > 
                    <el-form-item  label="手机号" prop="name">
                      <span class="name_class" >{{user.phone}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="20" style="padding-top: 10px;" > 
                    <el-form-item  label="新密码" prop="password">
                      <el-input class="name_class" type="password" v-model="mimaForm.password"   auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="20" > 
                    <el-form-item label="确认密码" prop="conpassword">
                      <el-input class="name_class" type="password" v-model="mimaForm.conpassword"   auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="20" > 
                    <el-form-item   label="手机验证码"  prop= "smsCode" >
                      <el-input class="name_class" type = "text" v-model="mimaForm.smsCode"  ></el-input>
                      <el-button type="button" @click="sendCode" class="el_reg" :disabled="disabled" v-if="disabled==false">发送验证码
                      </el-button>
                      <el-button type="button" @click="sendCode" class="el_reg"  :disabled="disabled" v-if="disabled==true">{{btntxt}}
                      </el-button>
                    </el-form-item> 
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer1">
                <el-button type="primary"  class="zlsub" @click.native="mimaSubmit" :loading="editLoading">提交</el-button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="企业邀请" name="three">
            <div class="jczl_div" v-show="user.invitestatus == '1'">
              <span class="jczl_span1">
                企业邀请
              </span></br>
              <span class="jczl_span2">
                您尚未加入任何企业
              </span>
            </div>
            <div class="jczl_div" v-show="user.invitestatus == '2'">
              <span class="jczl_span1">
                企业邀请
              </span></br>
              <span class="jczl_span2">
                您已成功加入 {{ user.companyusename }}
              </span>
            </div>
            <div v-show="user.invitestatus == '1'" style="padding:50px 0 50px 20px;background:#fff;border:1px solid #dfe6ec;">
              <el-form label-width="100px" label-left="50px" ref="mimaForm" >
                <span class="yq_span">{{user.managername}} 邀请您加入 {{user.companyusename}}</span>
                <el-row >
                  <el-col :span="16" > 
                    <el-form-item  label="企业名称：" prop="invitesCompanyName">
                      <span class="name_class" >{{ user.invitesCompanyName }}</span>
                    </el-form-item>
                    <el-form-item  label="管理员：" prop="invitesCompanyManager">
                      <span class="name_class" >{{ user.invitesCompanyManager }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" > 
                    <div>
                      <!-- <el-button plain class="nosub" @click.native="addSubmit" :loading="addLoading" >拒绝</el-button> -->
                      <el-button type="primary" class="oksub" @click.native="addSubmit" :loading="addLoading" >同意</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div v-show="user.invitestatus == '2'" style="padding:50px 0 50px 20px;background:#fff;border:1px solid #dfe6ec;">
              <el-form label-width="100px" label-left="50px" ref="mimaForm" >
                <el-row >
                  <el-col :span="16" > 
                    <el-form-item  label="企业名称：" prop="invitesCompanyName">
                      <span class="name_class" >{{user.invitesCompanyName}}</span>
                    </el-form-item>
                    <el-form-item  label="管理员：" prop="invitesCompanyManager">
                      <span class="name_class" >{{user.invitesCompanyManager}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" > 
                    <div>
                      <el-button  type="success" disabled class="succ">已接受邀请</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
             
            </div>
            <div v-show="user.invitestatus == '0'" style="padding:50px 0 50px 20px;background:#fff;border:1px solid #dfe6ec;">
              <div slot="footer" class="dialog-footer1">
                  <el-button type="info" disabled style="width:150px;margin-top: 10px;">还未有企业邀请</el-button>
              </div>
            </div>
          </el-tab-pane>
      </el-tabs>

      <!--企业邀请-->
      <el-dialog class="model-edit" title="企业邀请" :visible.sync="addFormVisible" 
        :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" ref="addForm">
          <el-row>
            <el-col> 
              <el-form-item label="企业名称：" prop="name">
               {{user.companyusename}}
              </el-form-item>
            </el-col>
            <el-col> 
              <el-form-item label="管理员：" prop="name">
                {{user.managername}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">同意</el-button>
        </div>
      </el-dialog>

    </section>
    <!-- <div class="ftBox">
      <div class="ft">
        <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a></p>
      </div>
    </div> -->

  </div>

</template>
<script>
import { API__code,API__login, API__account } from '../../../api/index.js'
import upload from '../../../primary/Uploadtop'

export default {
  inject:['reload'],
  data(){
    return {
      addFormVisible:false,
      addLoading:false,
      addForm:{},

      checkCode:'',
      token:'',
      id:'',
      editLoading:false,
      editLoadingT:false,
      mimashoujiyzm:true,
      activeName: 'first',
      phone:'',
      btntxt: "重新发送",
      disabled: false,
      editForm:[],
      mimaForm:[],
      imageUrl: '',
      user:[],
      upLoadFileList:[],
      upLoadFileListd:'',
      picid:'',
      
    }
  },
  methods:{
    addSubmit(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        id:this.id,
      }
      API__account.accountOk(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
              message: '加入企业成功',
              type: 'success',
              center:true
          });
          this.addFormVisible = false;
          this.reload();
        }
      })
    },
    handleEdit:function(){
      this.addFormVisible = true;
    },
    hadSuccess:function(data){
      this.upLoadFileListd =  data;
      sessionStorage.setItem('photo', data);
      this.reload();
    },
    updatePic:function(data){
      this.editForm.picIds = data;
    },
    mimaSubmit:function(){
      this.editLoadingT = true;
      let param = {
        id:this.id,
        phone:this.user.phone,
        password:this.mimaForm.password,
        conpassword:this.mimaForm.conpassword,
        smsCode:this.mimaForm.smsCode,
        token:this.token,
        checkCode:this.checkCode,
      }
      API__login.forget(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
              message: '修改成功',
              type: 'success',
              center:true
          });
          this.reload();
          this.getProductList();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.editLoadingT = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editLoadingT = false;
      });
    },
    editSubmit:function(){
      let _this = this;
      if(!this.user.name){
        this.$message.error('姓名不可为空');
        return;
      }
      if(!this.user.company){
        this.$message.error('企业不可为空');
        return;
      }
      this.editLoading = true;
      let param = {
        id:this.id,
        token:this.token,
        checkCode:this.checkCode,
        phone:this.user.phone,
        mode:'update',
        name:this.user.name,
        company:this.user.company,
      }
      API__account.accountUpdate(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
              message: '修改成功',
              type: 'success',
              center:true
          });
          if(_this.user.name){
            sessionStorage.setItem('user', _this.user.name);
          }
          if(_this.user.company){
            sessionStorage.setItem('company', _this.user.company);
          }
          this.reload();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.editLoading = false;
      }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
          this.editLoading = false;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //发送验证码
    sendCode() {
        let para = {
            phone: this.user.phone,
        };
        API__login.sendSmsCode(para)
        .then((res) =>{
            if(res.data.code == API__code.SUCCESS ){
                this.$message({
                    message: '发送成功',
                    type: 'success',
                    center:true
                });
                this.time = 120;
                this.disabled = true;
                this.timer();
            }else{
                this.$message.error(res.data.message);
                if(res.data.code == 403){
                  this.$router.push({path: 'login'});
                }
            }
        }).catch(err =>{
              this.$message.error('数据丢失，试试重新登陆！');
              this.pageLoading = false;
        });
    },
    //120S倒计时
    timer() {
        if (this.time > 0) {
            this.time--;
            this.btntxt = this.time + "s后重新获取";
            setTimeout(this.timer, 1000);
        } else {
            this.time = 0;
            this.btntxt = "获取验证码";
            this.disabled = false;
        }
    },
    getProductList:function(){
      let params = {
        token:this.token,
        checkCode:this.checkCode,
        id:this.id,
      }
      let _this = this;
      API__account.accountDetail(params)
      .then((res)=>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data){
            this.user = res.data.data;
            this.picid = res.data.data.picid;
            if(res.data.data.photo){
              // _this.upLoadFileListd="http://192.168.100.230:8080/dnnCloud/" + res.data.data.photo;
              //  _this.upLoadFileListd="http://106.14.238.88:8080/dnnCloud/" + res.data.data.photo;
              _this.upLoadFileListd= res.data.data.photo;
              var json = {"picIds":_this.upLoadFileListd};
              _this.upLoadFileList.push(json);
            }
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'dnnypt_token') {
                this.token = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'dnnypt_checkCode') {
                this.checkCode = arr2[1];
            }
            // else if (arr2[0] == 'dnnypt_id') {
            //     this.id = arr2[1];
            // }
        }
      }
    },
  },
  mounted(){
    this.getProductList();
  },
  created(){
    this.getCookie();
  },
  components: {
		upload
	},
}
</script>
<style lang="scss" scoped>

.heard_img{
  height: 120px;
  width: 120px;
  /* float: left; */
  border-radius: 60px;
  border:1px solid #bfcbd9;
  position: relative;
  left: 20px;
}
.heard_img2{
  height: 180px;
  width: 140px;
  float: left;
  border-radius: 70px;
  
}
.el-form-item{
  margin-bottom: 0px;
}
.el-form-item__label{
  width:100px;
}
.names{
  left:-40px;
}

.danwei{
  left:-75px;
}
.el-input{
  position:  relative;
  top: 50px;
}
.shouji{
  position: relative;
  top: 70px;
  left:30px;
}
.shoujihaoma{
  position: relative;
  top: 45px;
  left:-70px;
}
.sjyzm{
  position: relative;
  top: 70px;
  left:15px;
}
.shoujiyzm{
  position: relative;
  top: 35px;
  left:-85px;
  color:#3d99fd;
  cursor:pointer;
}
.mimasjyzm{
  position: relative;
  left: -90px;
}
.dialog-footer1{
  position: relative;
  left: 100px;
  /* top: 60px;
  padding-bottom: 30px; */
}

.el_reg{
    width:130px;
    position: relative;
    top: 0px;
    right: 133px;
    height: 100%;
    background: #ecf5ff;
    color: #F66B3D;
    border-radius: 0 4px 4px 0;
    border-color: #c6e2ff;
    border-left-color: #F66B3D;
    &:hover{
        background: #c8e2ff;
    }
}
/* .el_reg:hover{
    width:130px;
    position: relative;
    top: 0px;
    right: 133px;
    height: 100%;
    background: #c8e2ff;
    color: #3a8ee6;
    border-radius: 0 4px 4px 0;
    border-color: #c6e2ff;
    border-left-color: #3a8ee6;
} */

.avatar-uploader .el-upload {
    /* border: 1px dashed #d9d9d9; */
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 96px;
    height: 36px;
    background: #F66B3D;
    color:#fff;
    font-size: 14px;
    font-weight: normal;
  }
  .avatar-uploader{
    position: relative;
    float: left;
    border-radius: 70px;
    z-index: 999;
    border:1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 140px;
    line-height: 140px;
    text-align: center;
  }
  .avatar {
    width: 140px;
    height: 140px;
    display: block;
  }
  .name_class{
    position: relative;
    top:0px;
    width:300px;
    padding-bottom: 20px;
  }
  .qyyq{
    position: relative;
    left: 30px;
    height: 25px;
    line-height: 5px;
  }
  .acc_tabs{
    position: absolute;
    top:20px;
  }
  .jczl_div{
    height: 100px;
    width: 100%;
  }
  .jczl_span1{
    font-size:20px;
    color:#666;
    font-weight:bold;
    position: relative;
    top:20px;
  }
  .jczl_span2{
    font-size:14px;
    color:#666;
    font-weight:normal;
    position: relative;
    top:30px;
  }
  .zlsub{
    width:224px;
    height: 40px;
    background: #F66B3D;
    border-color: #F66B3D;
    &:hover{
      background: #fc8b65;
      border-color: #fc8b65;
    }
  }
  .nosub{
    width:120px;
    margin-top: 10px;
    float:right;
    right:30px;
    position:relative;
  }
  .oksub{
    width:120px;
    margin-top: 10px;
    float:right;
    right:60px;
    position:relative;
    background: #F66B3D;
    border-color: #F66B3D;
    border-left-color: #F66B3D;
    &:hover{
        background: rgb(253, 164, 134);
        border-color: rgb(253, 164, 134);
        border-left-color: rgb(253, 164, 134);
    }
  }
  .yq_span{
    color: #333;
    position: relative;
    top: -15px;
    font-size: 18px;
    font-weight: bold;
    left: 20px;
  }
  .succ{
    width:120px;
    margin-top: 10px;
    margin-top: 10px;
    float:right;
    right:60px;
    position:relative;
    top:10px;
  }
</style>



// WEBPACK FOOTER //
// AccountList.vue?c9449554